<template>
  <MdModal
    :isopen="isOpen"
    width="776px"
    showoverlay="true"
    class="re-release-success-modal"
    data-qa-id="re-release-success-modal"
    @handleclose="$emit('close')"
  >
    <div slot="header">
      <h3 :class="$style.title">
        {{ $t('pages.reactivate_families.modal.title') }}
      </h3>
    </div>
    <div slot="body" :class="$style.body">
      <img :src="illustration" alt="" :class="$style.illustration" />
      <div :class="$style.textGroup">
        <div :class="$style.desc">
          <p :class="$style.descLine">{{ $t('pages.reactivate_families.modal.description_line1') }}</p>
          <p :class="$style.descLine">{{ $t('pages.reactivate_families.modal.description_line2') }}</p>
        </div>
        <p :class="$style.descBold">
          {{ $t('pages.reactivate_families.modal.description_bold') }}
        </p>
      </div>
    </div>
    <div slot="footer" :class="$style.footer">
      <MdButton size="large" variant="none" color="lightgrey" @handleclick="$emit('close')" data-qa-id="re-release-modal-close">
        {{ $t('pages.reactivate_families.modal.close') }}
      </MdButton>
      <MdButton size="large" variant="none" color="blue" @handleclick="$emit('go-to-dashboard')" data-qa-id="re-release-modal-dashboard">
        {{ $t('pages.reactivate_families.modal.go_to_dashboard') }}
      </MdButton>
    </div>
  </MdModal>
</template>

<script>
import { MdModal, MdButton } from '@antiqua-dls/vue-components'
import illustration from 'src/pages/success/assets/monotype-outline-illustration.svg'

export default {
  name: 'ReReleaseSuccessModal',
  components: { MdModal, MdButton },
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ['close', 'go-to-dashboard'],
  data () {
    return { illustration }
  }
}
</script>

<style lang="scss" module>
.title {
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
  letter-spacing: 0;
  color: var(--md-color--spirits--900, #1E242C);
  margin: 0;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 40px;
}

.illustration {
  width: 240px;
  height: 240px;
  object-fit: contain;
}

.textGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  text-align: center;
  width: 100%;
}

.desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.32px;
  color: var(--md-color--spirits--600, #576579);
  margin: 0;
  width: 100%;
}

.descLine {
  margin: 0;
}

.descBold {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.32px;
  color: var(--md-color--spirits--900, #0E1013);
  margin: 0;
}

.footer {
  display: flex;
  gap: 16px;
}
</style>

<style lang="scss">
.re-release-success-modal {
  &::part(md-modal__content) {
    border-radius: 16px;
    overflow: hidden;
    gap: 0;
  }

  &::part(md-modal__header) {
    padding: 40px 40px 24px 40px;
    border-bottom: 1px solid var(--md-border-grey, #DBDFE5);
  }

  &::part(md-modal__body) {
    padding: 0;
    border-bottom: 1px solid var(--md-border-grey, #DBDFE5);
  }

  &::part(md-modal__footer) {
    padding: 24px 40px 40px 40px;
    border-top: none;
  }
}
</style>
